var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54831 2.35767C4.07627 2.35767 3.69361 2.74033 3.69361 3.21237V12.785C3.69361 13.2571 4.07627 13.6397 4.54831 13.6397H11.3859C11.858 13.6397 12.2406 13.2571 12.2406 12.785V6.23064C12.2406 6.1853 12.2226 6.14182 12.1906 6.10977L8.48852 2.40774C8.45647 2.37568 8.41299 2.35767 8.36765 2.35767H4.54831ZM2.66797 3.21237C2.66797 2.17389 3.50983 1.33203 4.54831 1.33203H8.36765C8.685 1.33203 8.98936 1.4581 9.21376 1.6825L12.9158 5.38453C13.1402 5.60893 13.2663 5.91329 13.2663 6.23064V12.785C13.2663 13.8235 12.4244 14.6654 11.3859 14.6654H4.54831C3.50983 14.6654 2.66797 13.8235 2.66797 12.785V3.21237ZM5.40301 7.9987C5.40301 7.71548 5.63261 7.48588 5.91583 7.48588H10.0184C10.3016 7.48588 10.5312 7.71548 10.5312 7.9987C10.5312 8.28192 10.3016 8.51152 10.0184 8.51152H5.91583C5.63261 8.51152 5.40301 8.28192 5.40301 7.9987ZM5.40301 10.7337C5.40301 10.4505 5.63261 10.2209 5.91583 10.2209H10.0184C10.3016 10.2209 10.5312 10.4505 10.5312 10.7337C10.5312 11.017 10.3016 11.2466 10.0184 11.2466H5.91583C5.63261 11.2466 5.40301 11.017 5.40301 10.7337Z",
    fill: "#4B4F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.ea8cfc066a77daf1bdb76bfb03f8c0bf.svg";
export { ForwardRef as ReactComponent };